import { apiAxios } from "../apiConfig";

export const getVisibleVoteInfo = async () => {
  try {
    const response = await apiAxios.get("/vote-info/visible");
    return response.data;
  } catch (error) {
    console.error("Error fetching visible vote info:", error);
    throw error;
  }
};
